import * as React from 'react';
import styled from 'styled-components';
import { desktop } from '../../designSystem/BreakPoints';

type MainRightTwoColumnLayoutProps = {
    main: React.ReactNode;
    left: React.ReactNode;
    secondaryWidth?: string;
}
export function MainRightTwoColumnLayout(props:MainRightTwoColumnLayoutProps):JSX.Element
{
    return (
        <Wrapper mainLeft={false} secondaryWidth={props.secondaryWidth ?? '400px'}>
            <LeftColumn>
                {props.left}
            </LeftColumn>
            <RightColumn>
                {props.main}
            </RightColumn>
        </Wrapper>
    );
}

type MainLeftTwoColumnLayoutProps = {
    main: React.ReactNode;
    right: React.ReactNode;
    secondaryWidth?: string;
}
export function MainLeftTwoColumnLayout(props:MainLeftTwoColumnLayoutProps):JSX.Element
{
    return (
        <Wrapper mainLeft={true} secondaryWidth={props.secondaryWidth ?? '400px'}>
            <LeftColumn>
                {props.main}
            </LeftColumn>
            <RightColumn>
                {props.right}
            </RightColumn>
        </Wrapper>
    );
}

const Wrapper = styled.div<{mainLeft:boolean, secondaryWidth:string}>`
    display: grid;
    grid-template-areas: 
        "leftColumn"
        "rightColumn";
    grid-template-columns:1fr;
    gap: 32px;

    @media (min-width: ${desktop}px) {
        grid-template-areas: 
            "leftColumn rightColumn";
        grid-template-columns: ${props => props.mainLeft ? `1fr ${props.secondaryWidth}` : `${  props.secondaryWidth} 1fr`};
    }
`;

const LeftColumn = styled.div`
    grid-area: leftColumn;
`;

const RightColumn = styled.div`
    grid-area: rightColumn;
`;

